export const absolutePath = (pathname: string) => `${pathname}`;